<template>
  <div class="neon-badge">
    <div class="neon-badge__content">
      <div class="neon-badge__text"><slot /></div>
    </div>
  </div>
</template>
<script>
export default {
  name: 'NeonBadge',
}
</script>
<style lang="scss" scoped>
.neon-badge {
  background-color: var(--cod-gray);
  background: url('../../assets/images/backgrounds/bl-bundle-price-bg.png');
  background-repeat: no-repeat;
  background-size: 65px;
  border-radius: 84.5px;
  height: 65px;
  width: 65px;

  &__content {
    height: 87px;
    display: flex;
    flex-direction: column;
    align-items: center;
    justify-content: center;
    position: absolute;
    top: -10px;
    left: 5px;
  }
  &__text {
    font-size: rem(12px);
    font-weight: 700;
    line-height: rem(10px);
    text-align: center;
    width: 55px;
  }
}
</style>
